import { introBlocks, introHighlights } from "../data";

export default function Intro() {
  return (
    <section className="bg-background-100/60">
      <div className="site-container py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 items-center">
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-28 h-28 noise-dot rounded-lg" aria-hidden="true"></div>
            <div className="relative rounded-lg border-4 border-background-50 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20editorial%20flat%20illustration%20of%20a%20large%20magnifying%20glass%20examining%20a%20small%20glowing%20house%2C%20surrounded%20by%20floating%20little%20red%20warning%20flags%20and%20amber%20dotted%20lines%20pointing%20at%20it%2C%20soft%20cream%20paper%20background%20with%20coral%20red%20and%20warm%20gold%20accents%2C%20cozy%20minimal%20storytelling%20vector%20art%2C%20subtle%20grain%20and%20paper%20texture%2C%20generous%20negative%20space%2C%20print%20magazine%20editorial%20style%2C%20no%20text&width=900&height=760&seq=nvshentafang-intro-02&orientation=squarish"
                alt="放大镜观察小屋并伴随红色警示旗的暖色插画，隐喻察觉塌房前兆"
                title="女神塌房预警 - 前兆侦查插画"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 right-3 md:right-6 flex items-center gap-2 rounded-md bg-accent-500 px-4 py-2.5 text-foreground-950">
              <i className="ri-shield-flash-line text-lg w-5 h-5 flex items-center justify-center" aria-hidden="true"></i>
              <span className="text-xs font-bold whitespace-nowrap">预警要趁早</span>
            </div>
          </div>

          <div className="mt-4 lg:mt-0">
            <span className="eyebrow text-primary-600">
              <i className="ri-focus-2-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              为什么值得关注
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl leading-snug text-foreground-950">
              塌房前，总有一段
              <span className="text-primary-600">「预警期」</span>
              被忽略了
            </h2>

            <div className="mt-6 space-y-4">
              {introBlocks.map((b) => (
                <div
                  key={b.title}
                  className="rounded-lg border border-background-200 bg-background-50 p-5"
                >
                  <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
                    <span className="flex items-center justify-center w-6 h-6 rounded-md bg-primary-100 text-primary-700">
                      <i className="ri-check-line text-sm w-4 h-4" aria-hidden="true"></i>
                    </span>
                    {b.title}
                  </h3>
                  <p className="mt-2 pl-8 text-sm md:text-[15px] leading-relaxed text-foreground-600">
                    {b.text}
                  </p>
                </div>
              ))}
            </div>

            <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-2.5">
              {introHighlights.map((h) => (
                <li
                  key={h}
                  className="flex items-start gap-2 text-sm text-foreground-700"
                >
                  <i className="ri-price-tag-3-line text-base text-accent-600 w-4 h-4 flex items-center justify-center mt-0.5" aria-hidden="true"></i>
                  {h}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}